export default __webpack_public_path__ + "static/media/arrow-previous.ed8201ba.svg";